import React from 'react';
import './SortIcon.scss';
import { selectIcon } from '../../UI/selector';

const SortIcon = (props) => {
    const asc = 'ASC NULLS LAST';
    const desc = 'DESC NULLS LAST';
    return (
        <React.Fragment>
            <span className="sort">
                <img className="sort_by_asc" onClick = {() => props.ascDescClick(props.keys,asc)} src = {selectIcon(props.ascDesc === asc?'activeDown':'down')} alt="calesdar" />
                <img className="sort_by_desc" onClick={() => props.ascDescClick(props.keys,desc)} src = {selectIcon(props.ascDesc === desc?'activeDown':'down')} alt="calesdar" />
            </span>
        </React.Fragment>
    )
}
export default SortIcon;